import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

export type TipColor = "success" | "warning" | "error";

export interface TipProps {
  title?: string;
  message: string;
  color?: TipColor;
}

const COLOR_MAP: Record<TipColor, { bg: string; border: string; title: string }> = {
  success: {
    bg: "rgba(33,178,166,0.08)",     // teal/green
    border: "#21b2a6",
    title: "Tip",
  },
  warning: {
    bg: "rgba(255,167,38,0.12)",     // orange/amber
    border: "#ffa726",
    title: "Warning",
  },
  error: {
    bg: "rgba(244,67,54,0.10)",      // red
    border: "#f44336",
    title: "Error",
  },
};

const Tip = (props: TipProps) => {
  const { title, message, color = "success" } = props;
  const theme = COLOR_MAP[color];

  return (
    <MDBox
      p={3}
      borderRadius="lg"
      sx={{
        backgroundColor: theme.bg,
        borderLeft: `4px solid ${theme.border}`,
      }}
    >
      <MDTypography fontWeight="medium" mb={1}>
        {title ?? theme.title}
      </MDTypography>
      <MDTypography variant="body2" color="text.secondary">
        {message}
      </MDTypography>
    </MDBox>
  );
};

export default Tip;
